import axios from 'axios'
import QS from 'qs';
import router from './router';
import store from './store'
import { Message } from 'element-ui';

axios.defaults.timeout = 60000;
axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials=true;
axios.defaults.crossDomain=true;

// 每次请求都为http头增加Authorization字段，其内容为Token
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('cashier-pc-v2-token');
        if (token) {
            config.headers.common['token'] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// http response 拦截器
axios.interceptors.response.use(response => {
    if (response.status === 200) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
}, error => {
    if(error.code == 'ECONNABORTED'){
        Message.error('网络请求超时');
    }else if (error.response.status) {
        switch (error.response.status) {
            // 未登录跳转登录页面，携带当前页面路径，登录成功后返回当前页面
            //token过期，清除本地token和清空vuex中token对象
            // case 302: //401
            //     Message.error('登录过期，请重新登录');
            //     // 清除token
            //     localStorage.removeItem('token');
            //     store.commit('logout');
            //     router.replace({
            //         path: '/login',
            //         // query: {
            //         //     redirect: router.currentRoute.fullPath
            //         // }
            //     });
            //     break;
            case 403:
                Message.error('无访问权限，请重新登录');
                // 清除token
                localStorage.removeItem('cashier-pc-v2-token');
                store.commit('logout');
                router.replace({path: '/login'});
                break;
            //请求不存在
            case 404:
                Message.error('网络请求不存在');
                break;
            //请求不存在
            case 500:
                Message.error('网络请求异常');
                break;
        }
        return Promise.reject(error.response);
    }
});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}){
    params['timestamp'] = new Date().getTime();
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err =>{
            reject(err)
        })
    });
}

/**
 * del方法，delete  删除
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err =>{
            reject(err)
        })
    });
}

/**
 * post方法，对应post请求  新增
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err =>{
                reject(err)
            })
    });
}

/**
 * put，对应put请求  修改
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, QS.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err =>{
                reject(err)
            })
    });
}

//json传参
export function postJson(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err =>{
                reject(err)
            })
    });
}

